import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { StyledForm, StyledInput, SubmitButton, ErrorMessage, StyledImage, StyledComment, InputWrapper, SuccessMessage, EyeStyled, SuccessMessageWrapper } from '../styled';
import { BASE_URL } from '../../../environment/environment';
import logo from '../../../images/logo.png';
import { Eye, EyeOff } from 'lucide-react';
import { CheckCircle } from 'lucide-react';

export const ResetPasswordForm = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');
  const token = queryParams.get('token');

  useEffect(() => {
    if (!email || !token) {
      setError('Brak tokenu lub adresu e-mail w URL');
      setTimeout(() => {
        navigate('/check-email');
      }, 3000);
    }
  }, [email, token, navigate]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    setSuccessMessage('');

    if (!email || !token) {
      setError('Brak tokenu lub adresu e-mail w URL');
      setLoading(false);
      setTimeout(() => {
        navigate('/check-email');
      }, 3000);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Hasła muszą być identyczne');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}/Auth/reset-password`, { email, token, newPassword }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        setSuccessMessage('Hasło zostało pomyślnie zresetowane, zaloguj się ponownie.');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setError(response.data.message || 'Błąd podczas resetowania hasła');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Błąd połączenia z serwerem');
    } finally {
      setLoading(false);
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  };

  return (
    <>
      {successMessage ? (
        <SuccessMessageWrapper>
          <CheckCircle size={50} />
          <SuccessMessage>{successMessage}</SuccessMessage>
        </SuccessMessageWrapper>
      ) : (
        <StyledForm onSubmit={handleResetPassword}>
          <StyledImage src={logo} alt="Logo" />
          <StyledComment>Wprowadź nowe hasło:</StyledComment>
          <InputWrapper>
            <StyledInput
              type={showPassword ? 'text' : 'password'}
              placeholder="Nowe hasło"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              disabled={loading}
            />
            <EyeStyled onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </EyeStyled>
          </InputWrapper>
          <InputWrapper>
            <StyledInput
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="Powtórz nowe hasło"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
            />
            <EyeStyled onClick={() => setShowConfirmPassword(!showConfirmPassword)} >
              {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </EyeStyled>
          </InputWrapper>
          <SubmitButton type="submit" disabled={loading || !newPassword || !confirmPassword}>
            {loading ? 'Wysyłanie...' : 'Zresetuj hasło'}
          </SubmitButton>
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </StyledForm>
      )}
    </>
  );
};
